import React, { useCallback } from 'react';
import { useLazyGetAllYPickLoginQrCodesQuery } from './apiYPickCredentials';
import { Button } from '@ydistri/ds';
import { downloadBlob } from './yPickCredentialsLib';
import { useAppDispatch } from '../../../store';
import { addToast } from '@ydistri/utils';

/**
 * Button to download all QR codes as a zip file.
 * Button is disabled while the download is in progress.
 * @constructor
 */
const DownloadAllQrCodesButton: React.FC = () => {
  const [trigger] = useLazyGetAllYPickLoginQrCodesQuery();
  const [downloading, setDownloading] = React.useState(false);
  const dispatch = useAppDispatch();

  const downloadHandler = useCallback(() => {
    setDownloading(true);

    dispatch(addToast({ message: 'Please wait while the system prepares all QR Codes' }));
    trigger()
      .unwrap()
      .then(qrBlob => {
        if (qrBlob) {
          downloadBlob(qrBlob, 'ypick_qr_codes.zip');
          dispatch(
            addToast({ message: 'Successfully downloaded QR Codes, check your Downloads folder' }),
          );
        }
      })
      .finally(() => {
        setDownloading(false);
      });
  }, [dispatch, trigger]);

  return (
    <Button onClick={downloadHandler} loading={downloading} disabled={downloading}>
      Download all QR codes
    </Button>
  );
};

export default DownloadAllQrCodesButton;
